import React from 'react';
import Icn from './Icn';
import styles from './CategoryTab.module.css';

const CategoryTab = ({ name, icon, readonly, category, onEdit, onDelete, onClick, activeDelete }) => {
    const handleClick = () => {
        onClick(category);
    }

    const onEditClick = (e) => {
        e.stopPropagation();
        onEdit(category);
    }

    const onDeleteClick = (e) => {
        e.stopPropagation();
        onDelete(category);
    }

    return (
        <div onClick={handleClick} className={styles.container}>
            {/* Edit Button */}
            {!readonly && (
                <div onClick={onEditClick} style={{ position: 'absolute', left: 10, top: 10, padding: 4 }}>
                    <Icn style={{ width: 18, height: 12 }}>edit</Icn>
                </div>
            )}

            {/* Details */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {icon}
                {name}
            </div>

            {/* Delete Button */}
            {activeDelete && (
                <div onClick={onDeleteClick} style={{ position: 'absolute', right: 10, top: 10, padding: 4 }}>
                    <Icn style={{ width: 18, height: 12 }}>delete</Icn>
                </div>
            )}
        </div>
    )
};

export default CategoryTab;
